import {
  BarChart3,
  Map,
  MapPin,
  Globe,
  AlertTriangle,
  FileBarChart,
  MousePointerClick,
  Printer,
} from 'lucide-react';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';

import AdPerformanceOverview from './components/AdPerformanceOverview';
import GeoCommandCenter from './components/GeoCommandCenter';
import MarketingReportsTab from './components/MarketingReportsTab';
import OptimizationAlerts from './components/OptimizationAlerts';
import PosterGenerator from './components/PosterGenerator';
import RegionalPerformance from './components/RegionalPerformance';
import TrafficIntelligence from './components/TrafficIntelligence';
import WidgetTelemetry from './components/widget-telemetry/WidgetTelemetry';

const NAV_ITEMS = [
  { to: '/admin/marketing/overview', icon: BarChart3, label: 'Overview' },
  { to: '/admin/marketing/map', icon: Map, label: 'Geo Map' },
  { to: '/admin/marketing/regions', icon: MapPin, label: 'Regions' },
  { to: '/admin/marketing/traffic', icon: Globe, label: 'Traffic' },
  { to: '/admin/marketing/widget-telemetry', icon: MousePointerClick, label: 'Widget Telemetry' },
  { to: '/admin/marketing/alerts', icon: AlertTriangle, label: 'Alerts' },
  { to: '/admin/marketing/reports', icon: FileBarChart, label: 'Reports' },
  { to: '/admin/marketing/posters', icon: Printer, label: 'Posters' },
];

export default function MarketingPage() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-bark-900 dark:text-stone-100">Marketing</h1>
        <p className="text-sm text-stone-500 dark:text-stone-400 mt-1">
          Ad performance, ticket availability, and geographic optimization
        </p>
      </div>
      <div className="flex gap-6 items-start">
        <nav className="w-44 flex-shrink-0">
          <ul className="flex flex-col gap-0.5">
            {NAV_ITEMS.map(({ to, icon: Icon, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition ${
                      isActive
                        ? 'text-moss-600 dark:text-moss-400 bg-moss-50 dark:bg-moss-900/20 font-medium'
                        : 'text-stone-600 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28]'
                    }`
                  }
                >
                  <Icon size={14} />
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex-1 min-w-0">
          <Routes>
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<AdPerformanceOverview />} />
            <Route path="map" element={<GeoCommandCenter />} />
            <Route path="regions" element={<RegionalPerformance />} />
            <Route path="traffic" element={<TrafficIntelligence />} />
            <Route path="widget-telemetry" element={<WidgetTelemetry />} />
            <Route path="alerts" element={<OptimizationAlerts />} />
            <Route path="reports" element={<MarketingReportsTab />} />
            <Route path="posters" element={<PosterGenerator />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
